import {
  SubscribeInventoryNotification,
  UnsubscribeInventoryNotification,
} from '~/features/guide/subscribeInventoryNotification.graphql'
import { useSwrGraphqlMutation } from '~/lib/graphql-request/swr'
import type { RestaurantId } from '~/lib/graphql/scalars'

export const useSubscribeInventoryNotificationMutation = (restaurantId: RestaurantId) => {
  const { trigger, data, error, isMutating } = useSwrGraphqlMutation(
    SubscribeInventoryNotification,
    {
      restaurantId,
    }
  )
  return {
    subscribeTrigger: trigger,
    subscribeData: data,
    subscribeError: error,
    subscribeIsMutating: isMutating,
  }
}

export const useUnsubscribeInventoryNotificationMutation = (restaurantId: RestaurantId) => {
  const { trigger, data, error, isMutating } = useSwrGraphqlMutation(
    UnsubscribeInventoryNotification,
    {
      restaurantId,
    }
  )
  return {
    unsubscribeTrigger: trigger,
    unsubscribeData: data,
    unsubscribeError: error,
    unsubscribeIsMutating: isMutating,
  }
}
